
    export default {
    
        "./Components": async () => {
          const importModule = await import("./src/Components.jsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      
  }
  